import { add, addDays, format, startOfWeek, subWeeks } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { StorePerformanceInterval, TransactionFilterType } from '../../constants';
import { Transaction, TransactionFilter } from '../../global-state/types';
import {
  AppCustomersResponse,
  AreaBreakdownData,
  AreaBreakdownKpi,
  AreaComparisonItem,
  AveragePiecesPerReceiptDataResponse,
  AveragePiecesPerReceiptPerformanceItem,
  BudgetPlanOverviewResponse,
  BudgetPlannedData,
  ConversionRateOverviewResponse,
  ConversionRateResponse,
  CurrencyConversionResponse,
  CustomerBaseValueViewResponse,
  CustomerEngagementResponse,
  CustomerEngagmentPerformanceItem,
  CustomerExperienceViewResponse,
  CustomerFeedback,
  CustomerFeedbackResponse,
  EfficiencyOverviewResponse,
  HelpASaleResponse,
  MemberOverviewResponse,
  NewMembersResponse,
  ORISResponse,
  PlanProductDetailsResponse,
  QueueCustomerOverviewResponse,
  QueueLengthForecastPerformanceItem,
  QueueLengthPerformanceItem,
  QueueLengthResponse,
  QueueLengthTillData,
  ReceiptSalesTimeResponse,
  SCOShareOfReceiptResponse,
  SalesEfficiencyMetrics,
  SalesEfficiencyViewResponse,
  SalesInsightsResponse,
  SalesNetPerReceiptPerformanceItem,
  SalesNetPerReceiptResponse,
  SalesNetPerformanceItem,
  SalesNetResponse,
  SalesOverviewResponse,
  SalesRetaggingPerformanceItem,
  ShareOfReceiptResponse,
  SoldProductDetailsResponse,
  StoreSalesData,
  StoreSalesPerformanceResponse,
  SummaryWidgetsResponse,
  TillType,
  TransactionCount,
  TransactionResponse,
} from '../../hooks';
import { getRandomNumber } from './profit-and-loss.mock';
import { mockStores, mockStoresDetails } from './store.mock';

export const getMockReceiptData = () => {
  return [
    '                      H&M                       ',
    '           H&M Hennes & Mauritz GmbH            ',
    '                 www.hm.com/AT                  ',
    '                     AT0168                     ',
    '      Riverside Breitenfurterstr. 372-380       ',
    '                  1230 Vienna                   ',
    '          Kundenservice 0800 66 55 900          ',
    '                  ATU19401608                   ',
    'Kassier: 375985      Store: AT0168     Bon: 3535',
    'Datum:23.02.21     Kassa:03        Zeit:13:55:07',
    '------------------------------------------------',
    'Einkaufstasche                  1St.            ',
    '999006                                      0,20',
    'Gürtel                          1St.            ',
    '0878223     S           Orange              1,99',
    '  Urspr. Preis                      9,99',
    '  Rabatt                           -8,00',
    'Fancy Jersey                    1St.            ',
    '0916222     152         Schwarz            22,99',
    'Other Sales                     1St.            ',
    '0452818     43/45       Schwarz             7,99',
    'Denim Kinder                    1St.            ',
    '0860172     152         Blau               24,99',
    'Fancy Jersey                    1St.            ',
    '0869158     152         Schwarz            17,99',
    'Denim Kinder                    1St.            ',
    '0860172     152         Blau               24,99',
    'Bluse                           1St.            ',
    '0925204     42          Blue               24,99',
    'Denim Damen                     1St.            ',
    '0399061     40          Blau               34,99',
    '------------------------',
    'PAKET                                           ',
    'Basic Jersey                    1St.            ',
    '0628327     152         Schwarz             7,14',
    '  Urspr. Preis                      9,99',
    'Basic Jersey                    1St.            ',
    '0628327     152         Schwarz             7,14',
    '  Urspr. Preis                      9,99',
    'Basic Jersey                    1St.            ',
    '0627554     146         Schwarz             5,70',
    '  Urspr. Preis                      7,99',
    '  Manueller Rabatt                 -7,99',
    '  Paketpreis                               19,98',
    '------------------------',
    '------------------------------------------------',
    'Total          181,10 €',
    'ANZAHL DER ARTIKEL 12                           ',
    'MWST%       MWST        Netto       Gesamt      ',
    '20,00       30,18       150,92      181,10      ',
    'Gesamt      30,18       150,92      181,10      ',
    '',
    'Rabatt Gesamt:                             15,99',
    'Erhalten    Maestro                       181,10',
    '',
    'KOPIE KARTENINHABER                             ',
    '',
    'Datum                         23/02/2021        ',
    'Uhrzeit                         13:56:21        ',
    '',
    'Karte                ***************8888        ',
    'PAN seq.                              01        ',
    'Bev. Name                        MAESTRO        ',
    'Kartentyp                        maestro        ',
    'Zahlungsmethode                  maestro        ',
    'Payment variant                  maestro        ',
    'Eingabemodus           Kontaktloser Chip        ',
    'CVM res.                     PIN GEPRÜFT        ',
    '',
    'AID                       A0000000043060        ',
    'MID                      526567002119688        ',
    'TID                      VX820-902561592        ',
    'PTID                            72334425        ',
    '',
    'Auth. code                        688206        ',
    'Tender               tVUH001298552181341        ',
    'Referenz         AT016800320210223135635        ',
    '',
    'Typ               WAREN_DIENSTLEISTUNGEN        ',
    'Summe                           € 181.10        ',
    '',
    'Genehmigt                                       ',
    '',
    'Für Ihre Unterlagen                             ',
    '',
    '',
    'Letzter Umtauschtag 25.03.21                    ',
    'Kassenidentfikationsnummer: AT016803            ',
    'Belegnummer: 90611                              ',
    '',
    '          Verlängerte Umtauschfristen           ',
    '     Alle Einkäufe, die zwischen 7.12.2020      ',
    '      und 24.12.2020 in unseren Geschäften      ',
    '    in Österreich getätigt wurden, kannst du    ',
    '    bis einschließlich 9.3.2021 zurückgeben.    ',
    '  Gilt nur für Einkäufe in den den H&M Stores   ',
    '   in Österreich im oben genannten Zeitraum.    ',
    '       Für alle Einkäufe ab dem 8.2.2021        ',
    ' gilt die reguläre Umtauschfrist von 30 Tagen.  ',
    '',
    '        Vielen Dank für deinen Einkauf!         ',
    '         Umtausch nur gegen Vorlage des         ',
    '         originalen Kassabons möglich.          ',
    '',
    '     Bitte beachte, dass der Umtausch sowie     ',
    '      die Rückgabe von Gesichtsmasken, aus      ',
    '    hygienischen Gründen, nicht möglich ist.    ',
    '',
    '',
    '[barcode 20210223016800303535 INTERLEAVED_2_5 barcode]',
    '',
  ];
};

const mockPaymentType = ['Card', 'Cash', 'CreditDebit', 'HouseAccount'];
const mockOperatorIds = ['A110001', 'A110003', 'A110004'];
const mockReceiptType = ['OnlineReturn', 'Sale', 'Return', 'ReturnFaultyOnline', 'ReturnFaulty'];
const mockPaymentCardType = ['VISA', 'MasterCard', 'Alipay'];
const mockStoreDateTime = new Date('2024-09-25T13:05:07');
const mockStoreOpeningHour = 9;

const getMockPaymentType = () => {
  return mockPaymentType[Math.floor(Math.random() * mockPaymentType.length)];
};

const getMockPaymentCardType = () => {
  return mockPaymentCardType[Math.floor(Math.random() * mockPaymentCardType.length)];
};

const getMockReceiptType = () => {
  return mockReceiptType[Math.floor(Math.random() * mockReceiptType.length)];
};

const getMockOperatorId = () => {
  return mockOperatorIds[Math.floor(Math.random() * mockOperatorIds.length)];
};

export const getMockTransactionData = (pageSize?: number): TransactionResponse => {
  const data: Transaction[] = [];
  const updatedPageSize = pageSize || 100;

  for (let i = 0; i < updatedPageSize; i++) {
    data.push({
      tillId: Math.floor(Math.random() * 10).toString(),
      receiptNumber: Math.floor(Math.random() * 1000).toString(),
      countryCode: 'SE',
      storeId: mockStores[0].storeId,
      tillType: 'Manual',
      sequenceNumber: Math.floor(Math.random() * 1000).toString(),
      paymentType: [getMockPaymentType()],
      paymentCardtype: [getMockPaymentCardType()],
      receiptType: getMockReceiptType(),
      businessDayDate: add(new Date(), { hours: Math.floor(Math.random() * 20) }).toISOString(),
      receiptSubType: getMockReceiptType(),
      amount: Math.floor(Math.random() * 1000).toString(),
      Transaction: {
        beginDateTime: new Date().toISOString(),
        endDateTime: new Date(new Date().setDate(new Date().getDate() + 1)).toISOString(),
        OperatorID: getMockOperatorId(),
        currencyCode: 'SEK',
      },
    });
  }
  return {
    data,
    paging: {
      countFromOldPartition: 0,
      nextBusinessDayDate: new Date().toISOString(),
      nextTransactionSubType: 'Sales',
    },
  };
};

export const getMockTransactionCountData = (
  type = TransactionFilterType.OperatorId,
  totalCount = 150,
): TransactionCount => {
  const mapping = {
    [TransactionFilterType.OperatorId]: mockOperatorIds,
    [TransactionFilterType.PaymentType]: mockPaymentType,
    [TransactionFilterType.ReceiptSubType]: mockReceiptType,
  };
  const count = {
    operatorId: totalCount,
    paymentType: totalCount,
    receiptSubType: totalCount,
  };
  const getCount = (isLastItem: boolean) => {
    if (isLastItem) return count[type];

    const itemCount = Math.floor(Math.random() * count[type]) || 0;
    count[type] = count[type] - itemCount;
    return itemCount;
  };

  return {
    totalCount: totalCount.toString(),
    filterData: {
      [type]: mapping[type].map((item, index) => ({
        item,
        count: getCount(index === mapping[type].length - 1).toString(),
      })),
    } as TransactionFilter,
  };
};

export const getSalesNetWidgetData = (useTimezone: boolean = true): SalesNetResponse => {
  const zonedDate = utcToZonedTime(mockStoreDateTime, mockStoresDetails[0].timezone);
  const hour = zonedDate.getHours();

  const netSales: SalesNetPerformanceItem[] = Array.from({ length: 24 }, (_, i) => ({
    timeUnit: i.toString(),
    netSales: useTimezone && i > hour ? 0 : Math.floor(Math.random() * 100000),
    netSalesSCO: useTimezone && i > hour ? 0 : Math.floor(Math.random() * 30000),
    netSalesRFIDSCO: useTimezone && i > hour ? 0 : Math.floor(Math.random() * 10000),
    netSalesMobile: useTimezone && i > hour ? 0 : Math.floor(Math.random() * 5000),
    regularNetSales: useTimezone && i > hour ? 0 : Math.floor(Math.random() * 60000),
  }));

  return {
    netSales,
    today: Math.floor(Math.random() * 1000000),
    todaySCO: Math.floor(Math.random() * 300000),
    todayRFIDSCO: Math.floor(Math.random() * 100000),
    todayMobile: Math.floor(Math.random() * 50000),
    todayRegular: Math.floor(Math.random() * 600000),
    lastWeek: Math.floor(Math.random() * 1000000),
    lastWeekSCO: Math.floor(Math.random() * 300000),
    lastWeekRFIDSCO: Math.floor(Math.random() * 100000),
    lastWeekMobile: Math.floor(Math.random() * 50000),
    lastWeekRegular: Math.floor(Math.random() * 600000),
    lastYear: Math.floor(Math.random() * 1000000),
    lastYearSCO: Math.floor(Math.random() * 300000),
    lastYearRFIDSCO: Math.floor(Math.random() * 100000),
    lastYearMobile: Math.floor(Math.random() * 50000),
    lastYearRegular: Math.floor(Math.random() * 600000),
    lastUpdated: new Date(),
  };
};

export const getBudgetPlannedData = (): BudgetPlannedData => {
  return {
    budget: 25000,
    planned: 8000,
  };
};

export const getConversionRateData = (useTimezone: boolean = true): ConversionRateResponse => {
  const data = [];
  const zonedDate = utcToZonedTime(mockStoreDateTime, mockStoresDetails[0].timezone);
  const hour = zonedDate.getHours();

  for (let i = 0; i < 24; i++) {
    data.push({
      timeUnit: i.toString(),
      payingCustomers: useTimezone && i > hour ? 0 : Math.floor(Math.random() * 100),
      nonPayingCustomers: useTimezone && i > hour ? 0 : Math.floor(Math.random() * 50),
      numberOfTills: Math.floor(Math.random() * 5),
    });
  }

  return {
    conversionRate: data,
    lastWeek: 200,
    lastYear: 100,
    today: 10,
    lastUpdated: new Date(),
  };
};

export const getNewMembersData = (useTimezone: boolean = true): NewMembersResponse => {
  const zonedDate = utcToZonedTime(mockStoreDateTime, mockStoresDetails[0].timezone);
  const hour = zonedDate.getHours();

  const newMembers = Array.from({ length: 24 }, (_, i) => ({
    timeUnit: i.toString(),
    newMembersCount: useTimezone && i > hour ? 0 : Math.floor(Math.random() * 100),
    totalTransactions: useTimezone && i > hour ? 0 : Math.floor(Math.random() * 100),
    unrecruited: Math.floor(Math.random() * 100),
  }));

  return {
    newMembers,
    lastUpdated: new Date(),
  };
};

export const getAppCustomersData = (): AppCustomersResponse => {
  return {
    newAppCustomers: 105,
    activeCustomers: 458,
    appCustomers: 243,
    lastUpdated: new Date(),
  };
};

const generateSORMockData = (useTimezone: boolean) => {
  const zonedDate = utcToZonedTime(mockStoreDateTime, mockStoresDetails[0].timezone);
  const hour = zonedDate.getHours();
  const mockData = [];
  for (let i = 0; i < 24; i++) {
    const totalTransactions = useTimezone && i > hour ? 0 : Math.floor(Math.random() * 100) + 1;
    const transactions = totalTransactions * Math.random();

    const entry = {
      timeUnit: i.toString(),
      totalTransactions,
      transactions,
    };

    mockData.push(entry);
  }
  return mockData;
};

export const getMockShareOfReceiptsData = (useTimezone: boolean = true): ShareOfReceiptResponse => {
  const mockData = generateSORMockData(useTimezone);

  return {
    shareOfReceipts: mockData.map((item) => ({
      timeUnit: item.timeUnit,
      totalTransactions: item.totalTransactions,
      memberTransactions: item.transactions,
    })),
    lastUpdated: new Date(),
  };
};

export const getMockSCOShareOfReceiptsData = (useTimezone: boolean = true): SCOShareOfReceiptResponse => {
  const mockData = generateSORMockData(useTimezone);

  return {
    shareOfReceiptsSCO: mockData.map((item) => ({
      timeUnit: item.timeUnit,
      totalTransactions: item.totalTransactions,
      totalSCOTransactions: item.transactions,
    })),
    lastUpdated: new Date(),
  };
};

export const getSalesNetPerReceiptData = (useTimezone: boolean = true): SalesNetPerReceiptResponse => {
  const mockEntries: SalesNetPerReceiptPerformanceItem[] = [];
  const zonedDate = utcToZonedTime(mockStoreDateTime, mockStoresDetails[0].timezone);
  const hour = zonedDate.getHours();

  for (let i = 0; i < 24; i++) {
    mockEntries.push({
      timeUnit: i.toString(),
      amount: useTimezone && i > hour ? 0 : Math.floor(Math.random() * (1000 - 100) + 100) / 100,
    });
  }

  return {
    today: Math.floor(Math.random() * 1000000),
    lastWeek: Math.floor(Math.random() * 100),
    lastYear: Math.floor(Math.random() * 100),
    netSalePerReceipt: mockEntries,
    lastUpdated: new Date(),
  };
};

export const getAveragePiecesPerReceiptData = (
  useTimezone: boolean = true,
): AveragePiecesPerReceiptDataResponse => {
  const mockEntries: AveragePiecesPerReceiptPerformanceItem[] = [];
  const zonedDate = utcToZonedTime(mockStoreDateTime, mockStoresDetails[0].timezone);
  const hour = zonedDate.getHours();

  for (let i = 0; i < 24; i++) {
    mockEntries.push({
      timeUnit: i.toString(),
      amount: useTimezone && i > hour ? 0 : Math.floor(Math.random() * (1000 - 100) + 100) / 100,
    });
  }

  return {
    today: Math.floor(Math.random() * 100),
    lastWeek: Math.floor(Math.random() * 100),
    lastYear: Math.floor(Math.random() * 100),
    piecesPerReceipt: mockEntries,
    lastUpdated: new Date(),
  };
};

export const getQueueLengthData = (useTimezone: boolean = true): QueueLengthResponse => {
  const tillTypes: TillType[] = ['DEFAULT', 'SELFCHECKOUT', 'null', 'SCO-MP'];

  const mockEntries: QueueLengthPerformanceItem[] = [];
  const zonedDate = utcToZonedTime(mockStoreDateTime, mockStoresDetails[0].timezone);
  const hour = zonedDate.getHours();

  const tillIdToTypeMap: Map<string, number> = new Map();

  for (let i = 0; i < 24; i++) {
    const tillData: QueueLengthTillData[] = [];

    for (let j = 0; j < 50; j++) {
      const tillId = `ZZ${j + 1}`;

      let tillTypeIndex = Math.floor(Math.random() * (tillTypes.length - 1 + 1) + 0);

      const existingTillTypeIndex = tillIdToTypeMap.get(tillId);

      if (existingTillTypeIndex != undefined) {
        tillTypeIndex = existingTillTypeIndex;
      }

      tillIdToTypeMap.set(tillId, tillTypeIndex);

      tillData.push({
        tillId: tillId,
        tillType: tillTypes[tillTypeIndex],
        queueCount: i < mockStoreOpeningHour || (useTimezone && i > hour) ? 0 : Math.floor(Math.random() * 100),
        transactions: i < mockStoreOpeningHour || (useTimezone && i > hour) ? 0 : Math.floor(Math.random() * 100),
      });
    }

    mockEntries.push({
      timeUnit: i.toString(),
      tillData: tillData,
    });
  }

  return {
    queueLength: mockEntries,
    checkoutExperience: {
      happyCheckoutExperienceCount: Math.floor(Math.random() * 100),
      totalCheckoutExperienceCount: Math.floor(Math.random() * 100),
    },
    lastUpdated: new Date(),
  };
};

export const getQueueLengthForecastData = (): QueueLengthForecastPerformanceItem[] => {
  const mockEntries: QueueLengthForecastPerformanceItem[] = [];

  for (let i = 0; i < 24; i++) {
    mockEntries.push({
      timeUnit: i.toString(),
      defaultQueueCount: Math.floor(Math.random() * 100),
      scoQueueCount: Math.floor(Math.random() * 100),
      defaultTransactionsCount: Math.floor(Math.random() * 100),
      scoTransactionsCount: Math.floor(Math.random() * 100),
    });
  }

  return mockEntries;
};

export const getCustomerFeedbackData = (): CustomerFeedbackResponse => {
  const generateRandomFeedbacks = (num: number) => {
    const feedbacks: CustomerFeedback[] = [];
    const sampleTexts: { [key: string]: string[] } = {
      '1': ['Terrible experience.', 'Will not recommend.', 'Awful service.', 'Very disappointed.'],
      '2': ['Not happy with the service.', 'Could be better.', 'Below average.', 'Needs improvement.'],
      '3': ['Just okay.', 'Average service.', 'Mediocre experience.', 'Nothing special.'],
      '4': ['Very satisfied.', 'Good service.', 'Quite pleased.', 'Met expectations.'],
      '5': ['Great service!', 'Excellent experience!', 'Loved it!', 'Amazing support.'],
    };

    // Ensure at least one feedback for each rating from 1 to 5
    for (let rating = 1; rating <= 5; rating++) {
      const texts = sampleTexts[rating.toString()];
      const randomText = texts[Math.floor(Math.random() * texts.length)];
      feedbacks.push({ text: randomText, rating });
    }

    // Generate the remaining feedbacks randomly
    for (let i = 5; i < num; i++) {
      const randomRating = Math.floor(Math.random() * 5) + 1;
      const texts = sampleTexts[randomRating.toString()];
      const randomText = texts[Math.floor(Math.random() * texts.length)];
      feedbacks.push({ text: randomText, rating: randomRating });
    }

    return feedbacks;
  };

  const feedback = generateRandomFeedbacks(15);

  return {
    feedback,
    lastUpdated: new Date(),
  };
};

export const getReceiptSalesAnalysisData = (): ReceiptSalesTimeResponse => {
  return {
    takt1: {
      today: Math.floor(Math.random() * 100),
      lastWeek: Math.floor(Math.random() * 100),
      lastYear: Math.floor(Math.random() * 100),
    },
    spt: {
      today: Math.floor(Math.random() * 100),
      lastWeek: Math.floor(Math.random() * 100),
      lastYear: Math.floor(Math.random() * 100),
    },
    effectiveHours: {
      today: 45564,
      lastWeek: 11443,
      lastYear: 9800,
    },
    lastUpdated: new Date(),
  };
};

export const getMockORISData = (): ORISResponse => {
  return {
    convertedORISCustomers: Math.floor(Math.random() * 10000) + 10,
    totalORISCustomer: Math.floor(Math.random() * 10000) + 6000,
    loyalOrisCustomerCount: Math.floor(Math.random() * 10000) + 2000,
    orisTotalSaleTime: Math.floor(Math.random() * 10000) + 6000,
    lastUpdated: new Date(),
  };
};

export const getMockStoreSalesData = (): StoreSalesData[] => {
  const generateHourlySales = () =>
    Array.from({ length: 12 }, (_, i) => ({
      hour: `${9 + i}:00`,
      netSale: Math.floor(Math.random() * 1000) + 100, // Sales between 100 and 1100
    }));

  const generateStoreSalesData = (numStores: number) =>
    Array.from({ length: numStores }, (_, i) => ({
      storeId: i === 0 ? `CA1343` : `US${Math.floor(1000 + Math.random() * 9000)}`,
      currency: i === 0 ? 'CAD' : 'USD', // CA1343 uses CAD
      hourlySales: generateHourlySales(),
      lastUpdated: '2024-07-01T13:15:26.333Z',
    }));

  const storesNetSales = generateStoreSalesData(12);
  return storesNetSales;
};

export const getMockCustomerEngagementData = (): CustomerEngagementResponse => {
  return {
    lastUpdated: new Date(),
    storeTraffic: 63000,
    memberRecruited: {
      recruitment: 63000,
      inStoreCareApp: 7000,
    },
    memberIdentification: {
      membersIdentified: 67000,
      memberPurchases: 5000,
    },
    articleLookups: {
      lookups: 67000,
      purchasedArticles: 5000,
    },
  };
};

export const getMockCustomerEngagementForecastData = (): CustomerEngagmentPerformanceItem[] => {
  const mockEntries: CustomerEngagmentPerformanceItem[] = [];

  for (let i = 0; i < 24; i++) {
    mockEntries.push({
      timeUnit: i.toString(),
      customerEngaged: Math.floor(Math.random() * 100),
      storeTraffic: Math.floor(Math.random() * 100),
    });
  }

  return mockEntries;
};

export const getMockSalesRetaggingForecastData = (): SalesRetaggingPerformanceItem[] => {
  const mockEntries: SalesRetaggingPerformanceItem[] = [];

  for (let i = 0; i < 24; i++) {
    mockEntries.push({
      timeUnit: i.toString(),
      amount: Math.floor(Math.random() * 100),
    });
  }

  return mockEntries;
};

export const getMockSalesInsightsData = (
  interval: StorePerformanceInterval = StorePerformanceInterval.DAILY,
): SalesInsightsResponse => {
  const dailyData = [];
  for (let i = 0; i < 24; i++) {
    const totalSales = Math.floor(Math.random() * 1000);
    const entry = {
      timeUnit: i.toString(),
      sales: totalSales * Math.random() * 10,
      salesByTotal: totalSales * Math.random(),
      customers: totalSales * Math.random(),
      customersByTotal: totalSales * Math.random(),
      salesByCustomer: totalSales * Math.random(),
      itemsSold: totalSales * Math.random(),
      itemsSoldByCustomer: totalSales * Math.random() * 0.5, // Assuming items sold by customer is less than total items sold
    };

    dailyData.push(entry);
  }

  const randomWeekStart = startOfWeek(subWeeks(new Date(), Math.floor(Math.random() * 52)));
  const weeklyData = Array.from({ length: 7 }, (_, i) => {
    const date = addDays(randomWeekStart, i);
    const totalSales = Math.floor(Math.random() * 1000);
    return {
      timeUnit: format(date, 'yyyy-MM-dd'),
      sales: totalSales * Math.random(),
      salesByTotal: totalSales * Math.random(),
      customers: totalSales * Math.random(),
      customersByTotal: totalSales * Math.random(),
      salesByCustomer: totalSales * Math.random(),
      itemsSold: totalSales * Math.random(),
      itemsSoldByCustomer: totalSales * Math.random(),
    };
  });

  return {
    lastUpdated: new Date(),
    totalReceiptsWithoutReturns: Math.floor(Math.random() * 1000),
    salesInsight: interval === StorePerformanceInterval.WEEKLY ? weeklyData : dailyData,
  };
};

export const getMockAreaComparisonData = (): AreaComparisonItem[] => {
  const metrics = [
    {
      name: 'averageNetSale',
      min: 50,
      max: 100,
      factor: 1000,
    },
    {
      name: 'averageVisitors',
      min: 1000,
      max: 2000,
      decimals: 0,
    },
    {
      name: 'averageConversionRate',
      min: 15,
      max: 30,
    },
    {
      name: 'averageTakt1',
      min: 800,
      max: 1200,
    },
    {
      name: 'averagePiecesPerReceipt',
      min: 1,
      max: 3,
    },
    {
      name: 'averageSPT',
      min: 5,
      max: 15,
    },
    {
      name: 'averagePurchasePerReceipt',
      min: 200,
      max: 400,
    },
    {
      name: 'averageEffectiveHours',
      min: 40,
      max: 60,
    },
  ];

  const data = metrics.map((metric) => ({
    name: metric.name as SalesEfficiencyMetrics,
    today: getRandomNumber(
      metric.min * (metric.factor || 1),
      metric.max * (metric.factor || 1),
      metric.decimals || 2,
    ),
    lastWeek: getRandomNumber(
      metric.min * (metric.factor || 1),
      metric.max * (metric.factor || 1),
      metric.decimals || 2,
    ),
    lastYear: getRandomNumber(
      metric.min * (metric.factor || 1),
      metric.max * (metric.factor || 1),
      metric.decimals || 2,
    ),
    lastWeekArea: getRandomNumber(
      metric.min * (metric.factor || 1),
      metric.max * (metric.factor || 1),
      metric.decimals || 2,
    ),
    lastYearArea: getRandomNumber(
      metric.min * (metric.factor || 1),
      metric.max * (metric.factor || 1),
      metric.decimals || 2,
    ),
  }));

  return data;
};

// Area Overview Widget Mock Data
export const getMockSalesOverviewData = (): SalesOverviewResponse => {
  return {
    regularSales: Math.floor(Math.random() * 1000000),
    regularSalesLW: Math.floor(Math.random() * 1000000),
    regularSalesLY: Math.floor(Math.random() * 1000000),
    scoSales: Math.floor(Math.random() * 1000000),
    scoSalesLW: Math.floor(Math.random() * 1000000),
    scoSalesLY: Math.floor(Math.random() * 1000000),
  };
};

export const getMockEfficiencyOverviewData = (): EfficiencyOverviewResponse => {
  return {
    effectiveHours: Math.floor(Math.random() * 100000),
    effectiveHoursLW: Math.floor(Math.random() * 100000),
    effectiveHoursLY: Math.floor(Math.random() * 100000),
    spt: Math.floor(Math.random() * 10),
    sptLW: Math.floor(Math.random() * 10),
    sptLY: Math.floor(Math.random() * 10),
    takt1: Math.floor(Math.random() * 100),
    takt1LW: Math.floor(Math.random() * 100),
    takt1LY: Math.floor(Math.random() * 100),
  };
};

export const getMockMemberOverviewData = (): MemberOverviewResponse => {
  const totalTransactions = Math.floor(Math.random() * 100000);
  const memberTransactions = Math.floor(Math.random() * totalTransactions);
  const scoTransactions = Math.floor(Math.random() * (totalTransactions - memberTransactions));
  return {
    memberTransactions,
    totalTransactions,
    scoTransactions,
  };
};

export const getMockConversionRateOverviewData = (): ConversionRateOverviewResponse => {
  return {
    totalTills: Math.floor(Math.random() * 10) + 1,
    totalVisitors: Math.floor(Math.random() * 10000) + 10000,
    totalTransactionsLW: Math.floor(Math.random() * 10000) + 1000,
    totalTransactionsLY: Math.floor(Math.random() * 10000) + 1000,
    totalVisitorsLW: Math.floor(Math.random() * 10000) + 10000,
    totalVisitorsLY: Math.floor(Math.random() * 10000) + 10000,
    totalTransactions: Math.floor(Math.random() * 10000) + 1000,
  };
};

export const getMockQueueCustomerOverviewData = (): QueueCustomerOverviewResponse => {
  return {
    overallQueueLength: Math.floor(Math.random() * 100),
    customerEngagement: Math.floor(Math.random() * 100),
    customerEngagementCount: Math.floor(Math.random() * 1000),
    customerSatisfaction: Math.floor(Math.random() * 100),
  };
};

export const getMockBudgetPlanOverviewData = (): BudgetPlanOverviewResponse => {
  return {
    conversionRateBudget: Math.floor(Math.random() * 100),
    conversionRatePlan: Math.floor(Math.random() * 100),
    netSalesBudget: Math.floor(Math.random() * 1000000),
    netSalesPlan: Math.floor(Math.random() * 1000000),
    effectiveHoursBudget: Math.floor(Math.random() * 100000),
    effectiveHoursPlan: Math.floor(Math.random() * 100000),
    takt1Budget: Math.floor(Math.random() * 100),
    takt1Plan: Math.floor(Math.random() * 100),
    sptBudget: Math.floor(Math.random() * 10),
    sptPlan: Math.floor(Math.random() * 10),
  };
};

export const getMockSummaryWidgetsData = (): SummaryWidgetsResponse => {
  return {
    kpis: Math.floor(Math.random() * 10),
    totalTransactions: Math.floor(Math.random() * 10000) + 1000,
    totalNewMembers: Math.floor(Math.random() * 1000) + 100,
    totalSoldPieces: Math.floor(Math.random() * 10000) + 1000,
    totalReturnedPieces: Math.floor(Math.random() * 1000) + 100,
    highlightedWidgets: Math.floor(Math.random() * 10),
    totalDiscountedTransactions: Math.floor(Math.random() * 1000) + 100,
  };
};

export const getMockHelpASaleData = (interval: string): HelpASaleResponse => {
  let salesArray = [];
  if (interval === 'Weekly') {
    salesArray = [
      {
        helpASaleSales: 1000,
        nonHelpASaleSales: 2000,
        timeUnit: '2026-02-01',
      },
      {
        helpASaleSales: 3000,
        nonHelpASaleSales: 2500,
        timeUnit: '2026-02-02',
      },
      {
        helpASaleSales: 4000,
        nonHelpASaleSales: 2000,
        timeUnit: '2026-02-03',
      },
      {
        helpASaleSales: 2400,
        nonHelpASaleSales: 2000,
        timeUnit: '2026-02-04',
      },
      {
        helpASaleSales: 1500,
        nonHelpASaleSales: 2000,
        timeUnit: '2026-02-05',
      },
      {
        helpASaleSales: 4000,
        nonHelpASaleSales: 4500,
        timeUnit: '2026-02-06',
      },
      {
        helpASaleSales: 3000,
        nonHelpASaleSales: 2000,
        timeUnit: '2026-02-07',
      },
    ];
  } else if (interval === 'Monthly') {
    salesArray = [
      {
        helpASaleSales: 10000,
        nonHelpASaleSales: 20000,
        timeUnit: 'Week 1',
      },
      {
        helpASaleSales: 30000,
        nonHelpASaleSales: 25000,
        timeUnit: 'Week 2',
      },
      {
        helpASaleSales: 45000,
        nonHelpASaleSales: 20000,
        timeUnit: 'Week 3',
      },
      {
        helpASaleSales: 15000,
        nonHelpASaleSales: 20000,
        timeUnit: 'Week 4',
      },
      {
        helpASaleSales: 30000,
        nonHelpASaleSales: 20000,
        timeUnit: 'Week 5',
      },
    ];
  } else {
    salesArray = [
      {
        helpASaleSales: 32123,
        nonHelpASaleSales: 82345.6789012,
        timeUnit: '2026-02-07',
      },
    ];
  }

  return {
    sales: salesArray,
    numberOfPieces: 10,
    customerFacingLookups: 46,
    visitors: 586,
    lastUpdated: new Date(),
  };
};

export const getMockCurrencyConversion = (): CurrencyConversionResponse => {
  const conversionRates = {
    BZD: 5.8159,
    GTQ: 1.4636,
    CRC: 0.11915,
    SEK: 1,
    USD: 9.9144,
    EUR: 12.2874,
  };

  return {
    conversionMap: conversionRates,
    lastUpdated: new Date(),
  };
};

export const getMockCustomerBaseValueData = (): CustomerBaseValueViewResponse => {
  return {
    customerBaseValue: [
      {
        storeId: 'SE0038',
        activeCustomers: 1000,
        unrecruitedCustomers: 200,
        memberShareOfReceipt: 15.5,
        appCustomers: 300,
        recruitedCustomers: 20,
        recruitedShare: 10.0,
      },
      {
        storeId: 'SE0663',
        activeCustomers: 800,
        unrecruitedCustomers: 150,
        memberShareOfReceipt: 20.0,
        appCustomers: 250,
        recruitedCustomers: 100,
        recruitedShare: 7.5,
      },
      {
        storeId: 'SE0144',
        activeCustomers: 600,
        unrecruitedCustomers: 100,
        memberShareOfReceipt: 10.0,
        appCustomers: 200,
        recruitedCustomers: 50,
        recruitedShare: 5.0,
      },
    ],
    summary: {
      activeCustomers: 2400,
      unrecruitedCustomers: 450,
      memberShareOfReceipt: 15.17,
      appCustomers: 750,
      recruitedCustomers: 200,
      recruitedShare: 8.33,
    },
  };
};

export const getMockSalesEfficiencyData = (): SalesEfficiencyViewResponse => {
  return {
    salesAndEfficiency: [
      {
        storeId: 'SE0038',
        sales: 150.75,
        salesLastWeek: 145.5,
        salesLastYear: 140.0,
        salesBudget: 160.0,
        conversionRate: 20.5,
        conversionRateLastWeek: 19.0,
        conversionRateLastYear: 18.0,
        takt1: 120,
        takt1LastWeek: 115,
        takt1LastYear: 110,
        takt1Budget: 130,
        spt: 8.5,
        sptLastWeek: 8.0,
        sptLastYear: 7.5,
        sptBudget: 9.0,
        effectiveHours: 100,
        effectiveHoursLastWeek: 95,
        effectiveHoursLastYear: 90,
        effectiveHoursBudget: 110,
      },
      {
        storeId: 'SE0663',
        sales: 180.25,
        salesLastWeek: 175.0,
        salesLastYear: 170.0,
        salesBudget: 190.0,
        conversionRate: 22.0,
        conversionRateLastWeek: 21.0,
        conversionRateLastYear: 20.0,
        takt1: 130,
        takt1LastWeek: 125,
        takt1LastYear: 120,
        takt1Budget: 140,
        spt: 9.0,
        sptLastWeek: 8.5,
        sptLastYear: 8.0,
        sptBudget: 9.5,
        effectiveHours: 110,
        effectiveHoursLastWeek: 105,
        effectiveHoursLastYear: 100,
        effectiveHoursBudget: 120,
      },
      {
        storeId: 'SE0144',
        sales: 120.5,
        salesLastWeek: 115.0,
        salesLastYear: 110.0,
        salesBudget: 130.0,
        conversionRate: 18.0,
        conversionRateLastWeek: 17.0,
        conversionRateLastYear: 16.0,
        takt1: 110,
        takt1LastWeek: 105,
        takt1LastYear: 100,
        takt1Budget: 120,
        spt: 7.0,
        sptLastWeek: 6.5,
        sptLastYear: 6.0,
        sptBudget: 7.5,
        effectiveHours: 90,
        effectiveHoursLastWeek: 85,
        effectiveHoursLastYear: 80,
        effectiveHoursBudget: 100,
      },
      {
        storeId: 'SE0144',
        sales: 200.0,
        salesLastWeek: 195.0,
        salesLastYear: 190.0,
        salesBudget: 210.0,
        conversionRate: 25.0,
        conversionRateLastWeek: 24.0,
        conversionRateLastYear: 23.0,
        takt1: 140,
        takt1LastWeek: 135,
        takt1LastYear: 130,
        takt1Budget: 150,
        spt: 10.0,
        sptLastWeek: 9.5,
        sptLastYear: 9.0,
        sptBudget: 10.5,
        effectiveHours: 110,
        effectiveHoursLastWeek: 105,
        effectiveHoursLastYear: 100,
        effectiveHoursBudget: 120,
      },
    ],
    summary: {
      sales: 651.5,
      salesLastWeek: 630.5,
      salesLastYear: 610.0,
      salesBudget: 690.0,
      conversionRate: 21.17,
      conversionRateLastWeek: 20.33,
      conversionRateLastYear: 19.33,
      takt1: 125,
      takt1LastWeek: 120,
      takt1LastYear: 115,
      takt1Budget: 130,
      spt: 8.5,
      sptLastWeek: 8.0,
      sptLastYear: 7.5,
      sptBudget: 9.0,
      effectiveHours: 200,
      effectiveHoursLastWeek: 190,
      effectiveHoursLastYear: 180,
      effectiveHoursBudget: 220,
    },
  };
};

export const getMockCustomerExperienceData = (): CustomerExperienceViewResponse => {
  return {
    customerExperience: [
      {
        storeId: 'SE0038',
        customerSatisfaction: 4.2,
        hoursSpent: 1.8,
        noOfScanners: 5,
        queueLength: 3.5,
        orisCR: 0.85,
        approvalRate: 0.9,
        addedSales: 1500,
        retaggingRate: 200,
        negDiff: 0.1,
      },
      {
        storeId: 'SE0663',
        customerSatisfaction: 4.0,
        hoursSpent: 1.5,
        noOfScanners: 4.5,
        queueLength: 4.0,
        orisCR: 0,
        approvalRate: 0,
        addedSales: 0,
        retaggingRate: 0,
        negDiff: 0,
      },
      {
        storeId: 'SE0144',
        customerSatisfaction: 4.5,
        hoursSpent: 2.0,
        noOfScanners: 6,
        queueLength: 5.0,
        orisCR: 0.9,
        approvalRate: 0.95,
        addedSales: 2000,
        retaggingRate: 300,
        negDiff: 0.2,
      },
    ],
    summary: {
      customerSatisfaction: 4.23,
      hoursSpent: 1.77,
      noOfScanners: 5.17,
      queueLength: 4.17,
      orisCR: 0.85,
      approvalRate: 0.95,
      addedSales: 1166.67,
      retaggingRate: 166.67,
      negDiff: 0.1,
    },
  };
};

export const getMockAreaBreakdownData = (
  kpi: AreaBreakdownKpi = 'netSales',
  interval: StorePerformanceInterval = StorePerformanceInterval.DAILY,
): AreaBreakdownData => {
  const sampleStoreIds = ['SE0421', 'SE0012', 'SE0112', 'SE27839', 'SE1111', 'SE2323', 'SE0009', 'SE0101'];

  let a = 0;
  let b = 0;

  if (kpi === 'netSales') {
    a = 500;
    b = 50000;
  }

  if (kpi === 'conversionRate' || kpi === 'queueLength' || kpi === 'shareOfReceipts') {
    a = 0;
    b = 100;
  }

  if (kpi === 'unrecruited') {
    a = 20;
    b = 500;
  }

  const dailyResponse: AreaBreakdownData = {
    kpi: kpi,
    breakdown: sampleStoreIds.map((id) => {
      return {
        storeId: id,
        values: Array.from({ length: 24 }, (_, i) => {
          return {
            timeUnit: i.toString(),
            amount: getRandomNumber(a, b),
          };
        }),
      };
    }),
  };

  if (interval === StorePerformanceInterval.DAILY) return dailyResponse;

  return dailyResponse;
};

export const getMockSalesPerformanceData = (): StoreSalesPerformanceResponse => {
  const salesPerformanceData = {
    lastCompleteDay: {
      budget: 47027.69,
      planned: 47027.69,
      visitors: {
        thisYear: 626,
        lastYear: 647,
        thisYearArea: 28419,
        lastYearArea: 24659,
        thisYearMarket: 64824,
        lastYearMarket: 62327,
      },
      receipts: {
        thisYear: 224,
        lastYear: 209,
        thisYearArea: 7907,
        lastYearArea: 7343,
        thisYearMarket: 19760,
        lastYearMarket: 18931,
      },
      departmentDetails: [
        {
          departmentNumber: '1222',
          departmentName: 'Blazer',
          index: '1',
          indexDescription: 'Womenswear',
          subIndex: '3',
          subIndexDescription: 'Womenswear Collection',
          garmentGroup: 'Dressed',
          sales: {
            salesNet: 78.2187,
            salesNetLastLastWeek: 0,
            salesNetLastYear: -43.901325,
            salesNetArea: 19084.733983,
            salesNetAreaLastYear: 17520.065736,
            salesNetMarket: 53041.496137,
            salesNetMarketLastYear: 54907.409690999986,
            nonFullPriceSales: 536.795,
            nonFullPriceSalesLastYear: -43.901325,
            nonFullPriceSalesArea: 7631.062383000001,
            nonFullPriceSalesLastYearArea: 11532.975636000001,
            soldPieces: 2,
            soldPiecesLastYear: 1,
            soldPiecesArea: 62,
            soldPiecesAreaLastYear: 68,
            soldPiecesMarket: 171,
            soldPiecesMarketLastYear: 221,
          },
        },
        {
          departmentNumber: '1313',
          departmentName: 'Tailoring Dress Inactive from S.2',
          index: '1',
          indexDescription: 'Womenswear',
          subIndex: '2',
          subIndexDescription: 'H&M Womens Tailoring',
          garmentGroup: 'Dresses Ladies',
          sales: {
            salesNet: 659.491,
            salesNetLastLastWeek: 0,
            salesNetLastYear: 1017.6102,
            salesNetArea: 10982.212220000001,
            salesNetAreaLastYear: 10995.638427,
            salesNetMarket: 30118.309815999997,
            salesNetMarketLastYear: 23596.129188000006,
            nonFullPriceSales: 659.491,
            nonFullPriceSalesLastYear: 225.135,
            nonFullPriceSalesArea: 9454.64702,
            nonFullPriceSalesLastYearArea: 4534.263927000001,
            soldPieces: 3,
            soldPiecesLastYear: 3,
            soldPiecesArea: 48,
            soldPiecesAreaLastYear: 46,
            soldPiecesMarket: 146,
            soldPiecesMarketLastYear: 101,
          },
        },
      ],
    },
    currentWeek: {
      budget: 161126.001,
      planned: 161126.001,
      visitors: {
        thisYear: 2032,
        lastYear: 2421,
        thisYearArea: 123026,
        lastYearArea: 108064,
        thisYearMarket: 301501,
        lastYearMarket: 294929,
      },
      receipts: {
        thisYear: 766,
        lastYear: 859,
        thisYearArea: 33470,
        lastYearArea: 32113,
        thisYearMarket: 90007,
        lastYearMarket: 88170,
      },
      departmentDetails: [
        {
          departmentNumber: '1212',
          departmentName: 'Tailoring Suit Inactive from S.2',
          index: '1',
          indexDescription: 'Womenswear',
          subIndex: '2',
          subIndexDescription: 'H&M Womens Tailoring',
          garmentGroup: 'Dressed',
          sales: {
            salesNet: 5194.6419000000005,
            salesNetLastLastWeek: 0,
            salesNetLastYear: 2733.364035,
            salesNetArea: 40072.368514,
            salesNetAreaLastYear: 67280.412235,
            salesNetMarket: 117715.91999700002,
            salesNetMarketLastYear: 185950.382418,
            nonFullPriceSales: 3205.433,
            nonFullPriceSalesLastYear: 2134.504935,
            nonFullPriceSalesArea: 31425.530214,
            nonFullPriceSalesLastYearArea: 42678.090735000005,
            soldPieces: 16,
            soldPiecesLastYear: 11,
            soldPiecesArea: 144,
            soldPiecesAreaLastYear: 214,
            soldPiecesMarket: 417,
            soldPiecesMarketLastYear: 602,
          },
        },
        {
          departmentNumber: '1322',
          departmentName: 'Dress & Jumpsuit',
          index: '1',
          indexDescription: 'Womenswear',
          subIndex: '3',
          subIndexDescription: 'Womenswear Collection',
          garmentGroup: 'Dresses Ladies',
          sales: {
            salesNet: 1486.8454649999999,
            salesNetLastLastWeek: 0,
            salesNetLastYear: -1830.6177119999998,
            salesNetArea: 45312.474098,
            salesNetAreaLastYear: 38700.88213400001,
            salesNetMarket: 160511.72673100003,
            salesNetMarketLastYear: 155825.281342,
            nonFullPriceSales: 677.0518649999999,
            nonFullPriceSalesLastYear: 9.485687999999996,
            nonFullPriceSalesArea: 49653.007798,
            nonFullPriceSalesLastYearArea: 48100.889934000006,
            soldPieces: 7,
            soldPiecesLastYear: 0,
            soldPiecesArea: 351,
            soldPiecesAreaLastYear: 432,
            soldPiecesMarket: 1141,
            soldPiecesMarketLastYear: 1352,
          },
        },
      ],
    },
    lastCompleteWeek: {
      budget: 227358.023,
      planned: 227358.023,
      visitors: {
        thisYear: 6027,
        lastYear: 3558,
        thisYearArea: 319799,
        lastYearArea: 159072,
        thisYearMarket: 736266,
        lastYearMarket: 442523,
      },
      receipts: {
        thisYear: 1800,
        lastYear: 1110,
        thisYearArea: 79647,
        lastYearArea: 43492,
        thisYearMarket: 203418,
        lastYearMarket: 123581,
      },
      departmentDetails: [
        {
          departmentNumber: '1116',
          departmentName: 'Tools',
          index: '11',
          indexDescription: 'Cosmetic',
          subIndex: '95',
          subIndexDescription: 'Make up & Tools',
          garmentGroup: 'Cosmetic',
          sales: {
            salesNet: 741.3514029999999,
            salesNetLastLastWeek: 184.602209,
            salesNetLastYear: 1211.128375,
            salesNetArea: 9539.516285000002,
            salesNetAreaLastYear: 18718.479525,
            salesNetMarket: 63528.76835300001,
            salesNetMarketLastYear: 77175.5915,
            nonFullPriceSales: -30.836,
            nonFullPriceSalesLastYear: 281.660175,
            nonFullPriceSalesArea: 1388.087327,
            nonFullPriceSalesLastYearArea: 9076.244335,
            soldPieces: 5,
            soldPiecesLastYear: 13,
            soldPiecesArea: 147,
            soldPiecesAreaLastYear: 283,
            soldPiecesMarket: 695,
            soldPiecesMarketLastYear: 1048,
          },
        },
        {
          departmentNumber: '1142',
          departmentName: 'Eyes',
          index: '11',
          indexDescription: 'Cosmetic',
          subIndex: '99',
          subIndexDescription: 'External Cosmetic',
          garmentGroup: 'Cosmetic',
          sales: {
            salesNet: 152.6382,
            salesNetLastLastWeek: 541.4667,
            salesNetLastYear: 550.378125,
            salesNetArea: 6023.409000000001,
            salesNetAreaLastYear: 10294.517399999999,
            salesNetMarket: 39451.873399000004,
            salesNetMarketLastYear: 41958.09216,
            nonFullPriceSales: 152.6382,
            nonFullPriceSalesLastYear: 550.378125,
            nonFullPriceSalesArea: 622.4805,
            nonFullPriceSalesLastYearArea: 10294.517399999999,
            soldPieces: 1,
            soldPiecesLastYear: 4,
            soldPiecesArea: 27,
            soldPiecesAreaLastYear: 72,
            soldPiecesMarket: 237,
            soldPiecesMarketLastYear: 286,
          },
        },
      ],
    },
    lastFourWeeks: {
      budget: 1900943.8760000002,
      planned: 1900943.8760000002,
      visitors: {
        thisYear: 27489,
        lastYear: 33725,
        thisYearArea: 1267368,
        lastYearArea: 1108317,
        thisYearMarket: 2873066,
        lastYearMarket: 2779129,
      },
      receipts: {
        thisYear: 8418,
        lastYear: 8930,
        thisYearArea: 317121,
        lastYearArea: 305403,
        thisYearMarket: 805257,
        lastYearMarket: 785323,
      },
      departmentDetails: [
        {
          departmentNumber: '1322',
          departmentName: 'Dress & Jumpsuit',
          index: '1',
          indexDescription: 'Womenswear',
          subIndex: '3',
          subIndexDescription: 'Womenswear Collection',
          garmentGroup: 'Dresses Ladies',
          sales: {
            salesNet: 28783.159259999997,
            salesNetLastLastWeek: 0,
            salesNetLastYear: 40696.346627000006,
            salesNetArea: 1028770.2079609998,
            salesNetAreaLastYear: 1332994.8970159998,
            salesNetMarket: 2767513.826349,
            salesNetMarketLastYear: 3326883.7911280002,
            nonFullPriceSales: 14420.707859999997,
            nonFullPriceSalesLastYear: 23869.742327,
            nonFullPriceSalesArea: 549182.038261,
            nonFullPriceSalesLastYearArea: 703541.811316,
            soldPieces: 128,
            soldPiecesLastYear: 149,
            soldPiecesArea: 4564,
            soldPiecesAreaLastYear: 5629,
            soldPiecesMarket: 11845,
            soldPiecesMarketLastYear: 14148,
          },
        },
        {
          departmentNumber: '1543',
          departmentName: 'Blouses',
          index: '4',
          indexDescription: 'Divided',
          subIndex: '24',
          subIndexDescription: 'Divided Collection',
          garmentGroup: 'Blouses',
          sales: {
            salesNet: 7191.280520000001,
            salesNetLastLastWeek: 0,
            salesNetLastYear: 10243.368593999998,
            salesNetArea: 291658.071054,
            salesNetAreaLastYear: 234982.888215,
            salesNetMarket: 688921.427468,
            salesNetMarketLastYear: 611446.7364339998,
            nonFullPriceSales: 3436.32842,
            nonFullPriceSalesLastYear: 2089.1153940000004,
            nonFullPriceSalesArea: 120354.98605399998,
            nonFullPriceSalesLastYearArea: 96045.77544500002,
            soldPieces: 50,
            soldPiecesLastYear: 62,
            soldPiecesArea: 1878,
            soldPiecesAreaLastYear: 2188,
            soldPiecesMarket: 4447,
            soldPiecesMarketLastYear: 5443,
          },
        },
      ],
    },
    accumulatedFinancialYearToDate: {
      budget: 2620363.727,
      planned: 2620363.727,
      visitors: {
        thisYear: 0,
        lastYear: 0,
        thisYearArea: 0,
        lastYearArea: 0,
        thisYearMarket: 0,
        lastYearMarket: 0,
      },
      receipts: {
        thisYear: 0,
        lastYear: 0,
        thisYearArea: 0,
        lastYearArea: 0,
        thisYearMarket: 0,
        lastYearMarket: 0,
      },
      departmentDetails: [
        {
          departmentNumber: '1111',
          departmentName: 'Eyes',
          index: '11',
          indexDescription: 'Cosmetic',
          subIndex: '95',
          subIndexDescription: 'Make up & Tools',
          garmentGroup: 'Cosmetic',
          sales: {
            salesNet: 0,
            salesNetLastLastWeek: 0,
            salesNetLastYear: 0,
            salesNetArea: 32535.51838,
            salesNetAreaLastYear: 59046.451172,
            salesNetMarket: 118891.976673,
            salesNetMarketLastYear: 219762.36353700003,
            nonFullPriceSales: 0,
            nonFullPriceSalesLastYear: 0,
            nonFullPriceSalesArea: 11141.028196000001,
            nonFullPriceSalesLastYearArea: 22329.416204,
            soldPieces: 0,
            soldPiecesLastYear: 0,
            soldPiecesArea: 610,
            soldPiecesAreaLastYear: 1069,
            soldPiecesMarket: 1865,
            soldPiecesMarketLastYear: 3734,
          },
        },
        {
          departmentNumber: '1112',
          departmentName: 'Nails',
          index: '11',
          indexDescription: 'Cosmetic',
          subIndex: '95',
          subIndexDescription: 'Make up & Tools',
          garmentGroup: 'Cosmetic',
          sales: {
            salesNet: 22025.718016,
            salesNetLastLastWeek: 0,
            salesNetLastYear: 24771.2189,
            salesNetArea: 149464.82925900002,
            salesNetAreaLastYear: 128083.15161,
            salesNetMarket: 527435.46259,
            salesNetMarketLastYear: 456785.12743199995,
            nonFullPriceSales: 11307.126725,
            nonFullPriceSalesLastYear: 3512.584314,
            nonFullPriceSalesArea: 86235.738706,
            nonFullPriceSalesLastYearArea: 39069.638809,
            soldPieces: 811,
            soldPiecesLastYear: 333,
            soldPiecesArea: 5285,
            soldPiecesAreaLastYear: 2048,
            soldPiecesMarket: 17123,
            soldPiecesMarketLastYear: 6997,
          },
        },
      ],
    },
  };

  return {
    ...salesPerformanceData,
    currentDay: salesPerformanceData.lastCompleteDay,
  };
};

export const getMockTopSoldProductsData = (): SoldProductDetailsResponse => {
  return {
    store: [
      {
        productId: 'P1001',
        articleId: 'A1001',
        productName: 'Classic White T-Shirt',
        departmentNumber: 'D01',
        departmentName: 'Menswear',
        subIndexId: 'SI10',
        subIndexDescription: 'Basics',
        indexId: '1',
        indexDescription: 'Apparel',
        price: 799,
        netSaleLastWeek: 52000,
        netSale: 134000,
        soldPieces: 75,
      },
      {
        productId: 'P1002',
        articleId: 'A1002',
        productName: 'Slim Fit Jeans',
        departmentNumber: 'D01',
        departmentName: 'Menswear',
        subIndexId: 'SI12',
        subIndexDescription: 'Denim',
        indexId: '1',
        indexDescription: 'Apparel',
        price: 1999,
        netSaleLastWeek: 88000,
        netSale: 94000,
        soldPieces: 47,
      },
      {
        productId: 'P1003',
        articleId: 'A1003',
        productName: 'Running Sneakers',
        departmentNumber: 'D03',
        departmentName: 'Footwear',
        subIndexId: 'SI21',
        subIndexDescription: 'Sports Shoes',
        indexId: '2',
        indexDescription: 'Footwear',
        price: 3499,
        netSaleLastWeek: 120000,
        netSale: 62000,
        soldPieces: 38,
      },
      {
        productId: 'P1004',
        articleId: 'A1004',
        productName: 'Cotton Polo Shirt',
        departmentNumber: 'D01',
        departmentName: 'Menswear',
        subIndexId: 'SI10',
        subIndexDescription: 'Basics',
        indexId: '1',
        indexDescription: 'Apparel',
        price: 1299,
        netSaleLastWeek: 45000,
        netSale: 80000,
        soldPieces: 40,
      },
      {
        productId: 'P1005',
        articleId: 'A1005',
        productName: 'Leather Belt',
        departmentNumber: 'D02',
        departmentName: 'Accessories',
        subIndexId: 'SI15',
        subIndexDescription: 'Belts & Ties',
        indexId: '1',
        indexDescription: 'Apparel',
        price: 899,
        netSaleLastWeek: 38000,
        netSale: 58000,
        soldPieces: 48,
      },
      {
        productId: 'P1006',
        articleId: 'A1006',
        productName: 'Crew Neck Sweater',
        departmentNumber: 'D01',
        departmentName: 'Menswear',
        subIndexId: 'SI11',
        subIndexDescription: 'Knitwear',
        indexId: '1',
        indexDescription: 'Apparel',
        price: 2499,
        netSaleLastWeek: 72000,
        netSale: 51000,
        soldPieces: 32,
      },
      {
        productId: 'P1007',
        articleId: 'A1007',
        productName: 'Casual Loafers',
        departmentNumber: 'D03',
        departmentName: 'Footwear',
        subIndexId: 'SI22',
        subIndexDescription: 'Casual Shoes',
        indexId: '2',
        indexDescription: 'Footwear',
        price: 2999,
        netSaleLastWeek: 65000,
        netSale: 72000,
        soldPieces: 24,
      },
      {
        productId: 'P1008',
        articleId: 'A1008',
        productName: 'Canvas Sneakers',
        departmentNumber: 'D03',
        departmentName: 'Footwear',
        subIndexId: 'SI21',
        subIndexDescription: 'Sports Shoes',
        indexId: '2',
        indexDescription: 'Footwear',
        price: 1899,
        netSaleLastWeek: 55000,
        netSale: 42000,
        soldPieces: 33,
      },
    ],

    area: [
      {
        productId: 'P1001',
        articleId: 'A1001',
        productName: 'Classic White T-Shirt',
        departmentNumber: 'D01',
        departmentName: 'Menswear',
        subIndexId: 'SI10',
        subIndexDescription: 'Basics',
        indexId: '1',
        indexDescription: 'Apparel',
        price: 799,
        netSaleLastWeek: 410000,
        netSale: 600000,
        soldPieces: 560,
      },
      {
        productId: 'P1002',
        articleId: 'A1002',
        productName: 'Slim Fit Jeans',
        departmentNumber: 'D01',
        departmentName: 'Menswear',
        subIndexId: 'SI12',
        subIndexDescription: 'Denim',
        indexId: '1',
        indexDescription: 'Apparel',
        price: 1999,
        netSaleLastWeek: 720000,
        netSale: 1050000,
        soldPieces: 380,
      },
      {
        productId: 'P1003',
        articleId: 'A1003',
        productName: 'Running Sneakers',
        departmentNumber: 'D03',
        departmentName: 'Footwear',
        subIndexId: 'SI21',
        subIndexDescription: 'Sports Shoes',
        indexId: '2',
        indexDescription: 'Footwear',
        price: 3499,
        netSaleLastWeek: 980000,
        netSale: 435000,
        soldPieces: 295,
      },
      {
        productId: 'P1004',
        articleId: 'A1004',
        productName: 'Cotton Polo Shirt',
        departmentNumber: 'D01',
        departmentName: 'Menswear',
        subIndexId: 'SI10',
        subIndexDescription: 'Basics',
        indexId: '1',
        indexDescription: 'Apparel',
        price: 1299,
        netSaleLastWeek: 350000,
        netSale: 530000,
        soldPieces: 298,
      },
      {
        productId: 'P1005',
        articleId: 'A1005',
        productName: 'Leather Belt',
        departmentNumber: 'D02',
        departmentName: 'Accessories',
        subIndexId: 'SI15',
        subIndexDescription: 'Belts & Ties',
        indexId: '1',
        indexDescription: 'Apparel',
        price: 899,
        netSaleLastWeek: 290000,
        netSale: 760000,
        soldPieces: 358,
      },
      {
        productId: 'P1006',
        articleId: 'A1006',
        productName: 'Crew Neck Sweater',
        departmentNumber: 'D01',
        departmentName: 'Menswear',
        subIndexId: 'SI11',
        subIndexDescription: 'Knitwear',
        indexId: '1',
        indexDescription: 'Apparel',
        price: 2499,
        netSaleLastWeek: 550000,
        netSale: 385000,
        soldPieces: 240,
      },
      {
        productId: 'P1007',
        articleId: 'A1007',
        productName: 'Casual Loafers',
        departmentNumber: 'D03',
        departmentName: 'Footwear',
        subIndexId: 'SI22',
        subIndexDescription: 'Casual Shoes',
        indexId: '2',
        indexDescription: 'Footwear',
        price: 2999,
        netSaleLastWeek: 480000,
        netSale: 465000,
        soldPieces: 178,
      },
      {
        productId: 'P1008',
        articleId: 'A1008',
        productName: 'Canvas Sneakers',
        departmentNumber: 'D03',
        departmentName: 'Footwear',
        subIndexId: 'SI21',
        subIndexDescription: 'Sports Shoes',
        indexId: '2',
        indexDescription: 'Footwear',
        price: 1899,
        netSaleLastWeek: 420000,
        netSale: 320000,
        soldPieces: 245,
      },
    ],

    salesMarket: [
      {
        productId: 'P1001',

        productName: 'Classic White T-Shirt',
        departmentNumber: 'D01',
        departmentName: 'Menswear',
        subIndexId: 'SI10',
        subIndexDescription: 'Basics',
        indexId: '1',
        indexDescription: 'Apparel',
        price: 799,
        netSaleLastWeek: 2200000,
        netSale: 2900000,
        soldPieces: 2980,
        articleId: 'A1001',
      },
      {
        productId: 'P1002',
        articleId: 'A1002',
        productName: 'Slim Fit Jeans',
        departmentNumber: 'D01',
        departmentName: 'Menswear',
        subIndexId: 'SI12',
        subIndexDescription: 'Denim',
        indexId: '1',
        indexDescription: 'Apparel',
        price: 1999,
        netSaleLastWeek: 3600000,
        netSale: 3250000,
        soldPieces: 1820,
      },
      {
        productId: 'P1003',
        articleId: 'A1003',
        productName: 'Running Sneakers',
        departmentNumber: 'D03',
        departmentName: 'Footwear',
        subIndexId: 'SI21',
        subIndexDescription: 'Sports Shoes',
        indexId: '2',
        indexDescription: 'Footwear',
        price: 3499,
        netSaleLastWeek: 5100000,
        netSale: 5480000,
        soldPieces: 1560,
      },
      {
        productId: 'P1004',
        articleId: 'A1004',
        productName: 'Cotton Polo Shirt',
        departmentNumber: 'D01',
        departmentName: 'Menswear',
        subIndexId: 'SI10',
        subIndexDescription: 'Basics',
        indexId: '1',
        indexDescription: 'Apparel',
        price: 1299,
        netSaleLastWeek: 1850000,
        netSale: 3820000,
        soldPieces: 1625,
      },
      {
        productId: 'P1005',
        articleId: 'A1005',
        productName: 'Leather Belt',
        departmentNumber: 'D02',
        departmentName: 'Accessories',
        subIndexId: 'SI15',
        subIndexDescription: 'Belts & Ties',
        indexId: '1',
        indexDescription: 'Apparel',
        price: 899,
        netSaleLastWeek: 1560000,
        netSale: 2350000,
        soldPieces: 2040,
      },
      {
        productId: 'P1006',
        articleId: 'A1006',
        productName: 'Crew Neck Sweater',
        departmentNumber: 'D01',
        departmentName: 'Menswear',
        subIndexId: 'SI11',
        subIndexDescription: 'Knitwear',
        indexId: '1',
        indexDescription: 'Apparel',
        price: 2499,
        netSaleLastWeek: 2950000,
        netSale: 2100000,
        soldPieces: 1305,
      },
      {
        productId: 'P1007',
        articleId: 'A1007',
        productName: 'Casual Loafers',
        departmentNumber: 'D03',
        departmentName: 'Footwear',
        subIndexId: 'SI22',
        subIndexDescription: 'Casual Shoes',
        indexId: '2',
        indexDescription: 'Footwear',
        price: 2999,
        netSaleLastWeek: 2640000,
        netSale: 2550000,
        soldPieces: 970,
      },
      {
        productId: 'P1008',
        articleId: 'A1008',
        productName: 'Canvas Sneakers',
        departmentNumber: 'D03',
        departmentName: 'Footwear',
        subIndexId: 'SI21',
        subIndexDescription: 'Sports Shoes',
        indexId: '2',
        indexDescription: 'Footwear',
        price: 1899,
        netSaleLastWeek: 2280000,
        netSale: 1820000,
        soldPieces: 1345,
      },
    ],
  };
};

export const getMockTopPlanProductsData = (): PlanProductDetailsResponse => {
  return [
    {
      productId: 'P1001',
      articleId: 'A1001',
      productName: 'Classic White T-Shirt',
      departmentNumber: 'D01',
      departmentName: 'Menswear',
      subIndexId: 'SI10',
      subIndexDescription: 'Basics',
      indexId: '1',
      indexDescription: 'Apparel',
      price: 799,
      planSales: 300000,
    },
    {
      productId: 'P1002',
      articleId: 'A1002',
      productName: 'Slim Fit Jeans',
      departmentNumber: 'D01',
      departmentName: 'Menswear',
      subIndexId: 'SI12',
      subIndexDescription: 'Denim',
      indexId: '1',
      indexDescription: 'Apparel',
      price: 1999,
      planSales: 280000,
    },
    {
      productId: 'P1003',
      articleId: 'A1003',
      productName: 'Running Sneakers',
      departmentNumber: 'D03',
      departmentName: 'Footwear',
      subIndexId: 'SI21',
      subIndexDescription: 'Sports Shoes',
      indexId: '2',
      indexDescription: 'Footwear',
      price: 3499,
      planSales: 260000,
    },
    {
      productId: 'P1004',
      articleId: 'A1004',
      productName: 'Cotton Polo Shirt',
      departmentNumber: 'D01',
      departmentName: 'Menswear',
      subIndexId: 'SI10',
      subIndexDescription: 'Basics',
      indexId: '1',
      indexDescription: 'Apparel',
      price: 1299,
      planSales: 240000,
    },
    {
      productId: 'P1005',
      articleId: 'A1005',
      productName: 'Leather Belt',
      departmentNumber: 'D02',
      departmentName: 'Accessories',
      subIndexId: 'SI15',
      subIndexDescription: 'Belts & Ties',
      indexId: '1',
      indexDescription: 'Apparel',
      price: 899,
      planSales: 220000,
    },
    {
      productId: 'P1006',
      articleId: 'A1006',
      productName: 'Crew Neck Sweater',
      departmentNumber: 'D01',
      departmentName: 'Menswear',
      subIndexId: 'SI11',
      subIndexDescription: 'Knitwear',
      indexId: '1',
      indexDescription: 'Apparel',
      price: 2499,
      planSales: 200000,
    },
    {
      productId: 'P1007',
      articleId: 'A1007',
      productName: 'Casual Loafers',
      departmentNumber: 'D03',
      departmentName: 'Footwear',
      subIndexId: 'SI22',
      subIndexDescription: 'Casual Shoes',
      indexId: '2',
      indexDescription: 'Footwear',
      price: 2999,
      planSales: 180000,
    },
    {
      productId: 'P1008',
      articleId: 'A1008',
      productName: 'Canvas Sneakers',
      departmentNumber: 'D03',
      departmentName: 'Footwear',
      subIndexId: 'SI21',
      subIndexDescription: 'Sports Shoes',
      indexId: '2',
      indexDescription: 'Footwear',
      price: 1899,
      planSales: 160000,
    },
  ];
};
